module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom-sp.a40fe795.jpg";